module.exports = __webpack_public_path__ + "img/firstNFT.6f7b3840.png";